export const wallet_routes = [
  { path: "/conta-scn", name: "Conta SCN", component: () => import("../Main.vue") },
  { path: "/conta-scn/adicionar", name: "Adicionar saldo", component: () => import("../DepositPix.vue") },
  { path: "/conta-scn/transferir", name: "Transferir saldo", component: () => import("../Transfer.vue") },
  { path: "/conta-scn/sacar", name: "Sacar via Pix", component: () => import("../WithdrawPix.vue") }
];

export default {};
